export const PASSWORD_REQUIREMENTS_MESSAGE =
  "La contraseña debe tener al menos 8 caracteres e incluir mayúsculas, " +
  "minúsculas, números y un carácter especial (por ejemplo: !@#$%&*).";

export function isStrongPassword(password) {
  if (typeof password !== "string" || password.length < 8) {
    return false;
  }

  const hasLowercase = /[a-z]/.test(password);
  const hasUppercase = /[A-Z]/.test(password);
  const hasNumber = /[0-9]/.test(password);
  const hasSpecialChar = /[^A-Za-z0-9]/.test(password);

  return hasLowercase && hasUppercase && hasNumber && hasSpecialChar;
}

// Este formulario ya no pregunta "Rol" (Cliente/Administrador): quien
// se crea desde aquí es una cuenta de acceso al panel, así que queda
// marcada como "ADMIN" (el campo legacy que usan algunos respaldos y
// validaciones del backend) y sus permisos reales — qué ve y qué puede
// hacer — dependen por completo de los roles que se le asignen abajo
// (módulo Roles). Al editar, se conserva el "role" que ya tenía el
// usuario; este formulario no lo cambia.
const DEFAULT_ROLE = "ADMIN";

export const initialValues = {
  firstname: "",
  lastname: "",
  email: "",
  password: "",
  number: "",
  role: DEFAULT_ROLE,
  roles: [],
  active: true,
  avatar: null,
};

export function getUserPayload(values = {}) {
  const payload = {
    firstname: String(values.firstname || "").trim(),
    lastname: String(values.lastname || "").trim(),
    email: String(values.email || "").trim().toLowerCase(),
    number: values.number || "",
    role: values.role || DEFAULT_ROLE,
    roles: Array.isArray(values.roles) ? values.roles : [],
    active: values.active !== false,
  };

  if (values.password) {
    payload.password = values.password;
  }

  if (values.avatar instanceof File) {
    payload.avatar = values.avatar;
  }

  return payload;
}
